import { takeEvery } from 'redux-saga/effects';
import { store } from '@redux/storeConfig/store';
import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../actions';
import * as schemas from '../schemas';
import * as types from '../types';
import {
  getUnitActionsService,
  saveUnitActionService,
  deleteUnitActionService,
  getUnitActionConfigurationsService,
  saveUnitActionConfigurationService,
  deleteUnitActionConfigurationService,
  getPermissionsService
} from '../services/unitActions';

// ── Unit Actions ──────────────────────────────────────────────────────────────
function* fetchUnitActions(action: any) {
  getUnitActionsService(action.payload, {
    successAction: (response) => {
      const resultData = response.data.map((r: any) => camelcaseKeys(r));
      const { entities: { unitActions }, result } = normalize(resultData, schemas.unitActions);
      store.dispatch(actions.completeFetchingUnitActions(unitActions ?? {}, result));
    },
    errorAction: (error) => store.dispatch(actions.failFetchingUnitActions(error))
  });
}
export function* watchFetchUnitActions() {
  yield takeEvery(types.UNIT_ACTIONS_FETCH_STARTED, fetchUnitActions);
}

function* addUnitAction(action: any) {
  const unitAction = action.payload;
  saveUnitActionService({ ...unitAction, unitActionId: null }, {
    successAction: (response) => {
      const added = camelcaseKeys(response.data);
      store.dispatch(actions.completeAddingUnitAction(unitAction.unitActionId, added));
    },
    errorAction: (error) => store.dispatch(actions.failAddingUnitAction(unitAction.unitActionId, error))
  });
}
export function* watchAddUnitAction() {
  yield takeEvery(types.UNIT_ACTIONS_ADD_STARTED, addUnitAction);
}

function* editUnitAction(action: any) {
  const unitAction = action.payload;
  saveUnitActionService(unitAction, {
    successAction: (response) => {
      const edited = camelcaseKeys(response.data);
      store.dispatch(actions.completeEditingUnitAction(edited));
    },
    errorAction: (error) => store.dispatch(actions.failEditingUnitAction(unitAction, error))
  });
}
export function* watchEditUnitAction() {
  yield takeEvery(types.UNIT_ACTIONS_EDIT_STARTED, editUnitAction);
}

function* removeUnitAction(action: any) {
  const { unitActionId } = action.payload;
  deleteUnitActionService({ unitActionId }, {
    successAction: () => store.dispatch(actions.completeRemovingUnitAction(unitActionId)),
    errorAction: (error) => store.dispatch(actions.failRemovingUnitAction(unitActionId, error))
  });
}
export function* watchRemoveUnitAction() {
  yield takeEvery(types.UNIT_ACTIONS_REMOVE_STARTED, removeUnitAction);
}

// ── Unit Action Configurations ────────────────────────────────────────────────
function* fetchUnitActionConfigurations(action: any) {
  getUnitActionConfigurationsService(action.payload, {
    successAction: (response) => {
      const resultData = response.data.map((r: any) => camelcaseKeys(r));
      const { entities: { unitActionConfigurations }, result } = normalize(resultData, schemas.unitActionConfigurations);
      store.dispatch(actions.completeFetchingUnitActionConfigurations(unitActionConfigurations ?? {}, result));
    },
    errorAction: (error) => store.dispatch(actions.failFetchingUnitActionConfigurations(error))
  });
}
export function* watchFetchUnitActionConfigurations() {
  yield takeEvery(types.UNIT_ACTION_CONFIGS_FETCH_STARTED, fetchUnitActionConfigurations);
}

function* addUnitActionConfiguration(action: any) {
  const config = action.payload;
  saveUnitActionConfigurationService({ ...config, unitActionConfigurationId: null }, {
    successAction: (response) => {
      const added = camelcaseKeys(response.data);
      store.dispatch(actions.completeAddingUnitActionConfiguration(config.unitActionConfigurationId, added));
    },
    errorAction: (error) => store.dispatch(actions.failAddingUnitActionConfiguration(config.unitActionConfigurationId, error))
  });
}
export function* watchAddUnitActionConfiguration() {
  yield takeEvery(types.UNIT_ACTION_CONFIGS_ADD_STARTED, addUnitActionConfiguration);
}

function* editUnitActionConfiguration(action: any) {
  const config = action.payload;
  saveUnitActionConfigurationService(config, {
    successAction: (response) => {
      const edited = camelcaseKeys(response.data);
      store.dispatch(actions.completeEditingUnitActionConfiguration(edited));
    },
    errorAction: (error) => store.dispatch(actions.failEditingUnitActionConfiguration(config, error))
  });
}
export function* watchEditUnitActionConfiguration() {
  yield takeEvery(types.UNIT_ACTION_CONFIGS_EDIT_STARTED, editUnitActionConfiguration);
}

function* removeUnitActionConfiguration(action: any) {
  const { unitActionConfigurationId } = action.payload;
  deleteUnitActionConfigurationService({ unitActionConfigurationId }, {
    successAction: () => store.dispatch(actions.completeRemovingUnitActionConfiguration(unitActionConfigurationId)),
    errorAction: (error) => store.dispatch(actions.failRemovingUnitActionConfiguration(unitActionConfigurationId, error))
  });
}
export function* watchRemoveUnitActionConfiguration() {
  yield takeEvery(types.UNIT_ACTION_CONFIGS_REMOVE_STARTED, removeUnitActionConfiguration);
}


function* fetchUnitActionPermissions() {
  getPermissionsService({
    successAction: (response) => {
      const permissions = response.data.map((r: any) => camelcaseKeys(r));
      store.dispatch(actions.completeFetchingUnitActionPermissions(permissions));
    },
    errorAction: (error) => store.dispatch(actions.failFetchingUnitActionPermissions(error))
  });
}
export function* watchFetchUnitActionPermissions() {
  yield takeEvery(types.PERMISSIONS_FETCH_STARTED, fetchUnitActionPermissions);
}

export default function* unitActionsSaga() {
  yield* [
    watchFetchUnitActions(),
    watchAddUnitAction(),
    watchEditUnitAction(),
    watchRemoveUnitAction(),
    watchFetchUnitActionConfigurations(),
    watchAddUnitActionConfiguration(),
    watchEditUnitActionConfiguration(),
    watchRemoveUnitActionConfiguration(),
  ];
}
